import React from 'react'

import { Button, Download, Icon, Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, shape, string } from 'prop-types'

const DownloadIcon = <Icon svgComponent={Download} size="small" />
const LoadingIcon = (
  <div className="cgt-icon cgt-icon__icon cgt-icon--default cgt-icon--primary">
    <Spinner size="xsmall" classNames="cgt-spinner--inline" />
  </div>
)

function FileRow({ file, label, pbrReadyLabel, disabled = false, isPending = false, onDownload }) {
  const handleClick = (event) => {
    event.preventDefault()

    if (!disabled) {
      onDownload(file)
    }
  }

  return (
    <li className="download-files-modal__file">
      <span className="download-files-modal__file-name cgt-body-md">{file.name}</span>
      {file.pbrReady && (
        <span className="download-files-modal__file-badge cgt-caption-semibold">{pbrReadyLabel}</span>
      )}
      <span className="download-files-modal__file-size cgt-body-md">{file.size}</span>
      <Button
        href={file.downloadUrl}
        linkAttributes={{ rel: 'nofollow', 'aria-label': label, 'aria-disabled': disabled || undefined }}
        onClick={handleClick}
        variant="only-icon"
        icon={isPending ? LoadingIcon : DownloadIcon}
        size="small"
        type="ghost"
        customClass="download-files-modal__file-action"
      />
    </li>
  )
}

FileRow.propTypes = {
  file: shape({
    id: number.isRequired,
    name: string.isRequired,
    size: string.isRequired,
    pbrReady: bool,
    downloadUrl: string.isRequired,
  }).isRequired,
  label: string.isRequired,
  pbrReadyLabel: string.isRequired,
  disabled: bool,
  isPending: bool,
  onDownload: func.isRequired,
}

export default FileRow
